import React, { useEffect, useState } from "react";
import "./customTagsForm.scss";
import { Form, Formik, FormikValues } from "formik";
import { Button, Col, Row, Switch } from "antd";
import InputField from "../../../shared/components/InputField";
import { customTagsFormValidation } from "./customTagsFormValidation";
import { CustomTags } from "../../../models/CustomTags/customTags.model";
import TagService from "../../../services/TagService/tag.service";

interface CustomTagsFormProps {
  customTags: CustomTags;
  onSuccess: (customTags: CustomTags) => void;
}

function CustomTagsForm({ customTags, onSuccess }: CustomTagsFormProps) {
  const [formValues, setFormValues] = useState<CustomTags>(customTags);

  const [formLoading, setFormLoading] = useState(false);

    const handleSubmit = (values: FormikValues) => {
        const customTag = Object.assign(new CustomTags(), values);

        setFormLoading(true);

        const payload = {
            tag: {
                name: customTag.name,
                color: customTag.color,
            },
        };

        if (customTag.id) {
            // UPDATE
            TagService.updateCustomTags(
                customTag.id,
                payload,
                (updatedTag: CustomTags) => {
                    onSuccess(updatedTag);
                },
                (error: any) => {
                    console.error(error);
                },
                () => {
                    setFormLoading(false);
                }
            );
        } else {
            // CREATE
            TagService.createCustomTags(
                payload,
                (createdTag: CustomTags) => {
                    onSuccess(createdTag);
                },
                (error: any) => {
                    console.error(error);
                },
                () => {
                    setFormLoading(false);
                }
            );
        }
    };



    // useEffect(() => {
  //   if (customTags.id) {
  //       TagService.fetchAdminTags(
  //       UserRoleEnum.ADMIN,
  //       (customTags: CustomTags) => {
  //         setFormValues(customTags);
  //       },
  //       () => {},
  //       () => {}
  //     );
  //   }
  // }, [customTags]);

  // @ts-ignore
    return (
    <div className="customTags-form">
      <h2 className="text-primary">
        {customTags.id ? "Edit Custom Tag" : "Add Custom Tag"}
      </h2>
      <Formik
        initialValues={formValues}
        onSubmit={handleSubmit}
        enableReinitialize
        validationSchema={customTagsFormValidation}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          isValid,
          dirty,
          setFieldValue,
        }) => {
          return (
            <Form>
              <Row gutter={[30, 0]}>
                <Col span={12}>
                  <InputField
                    title="Custom Tag Name"
                    type="text"
                    name="name"
                    placeholder="Enter Custom Tag Name"
                  />
                </Col>
                <Col span={12}>
                      <InputField
                        title="Color"
                        type="color"
                        name="color"
                        placeholder="Enter Color"
                      />
                </Col>
              </Row>
              <div className="customTags-form__submit-wrapper text-right mt-3">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={formLoading}
                  disabled={!isValid || formLoading}
                >
                  {customTags?.id ? "Update" : "Add"}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default CustomTagsForm;
